// @vendors
import React from "react";
import { useTranslation } from "react-i18next";

// @components
import UserRoleNavigation from "../../components/header/UserRoleNavigation";

// @store
import useAuthStore from "../../store/useAuthStore";
import { UserCircleIcon } from "@heroicons/react/24/solid";
import { useCompanyStore } from "../../store/useCompanyStore";
import { useLogoutStore } from "../../store/useLogoutStore";

// @helpers
import { getNameUser } from "../../helpers/functionsUtils";
import { useThemeStore } from "../../store/useThemeStore";

export const HeaderDashboard: React.FC = () => {
  const { isDarkMode } = useThemeStore();
  const { roleList } = useAuthStore();
  const { t } = useTranslation();
  const { data, userData } = useCompanyStore();
  const { handleLogout } = useLogoutStore();

  return (
    <header className={`lg:pl-4 pl-2 lg:pr-8 pr-2 lg:py-2.5 py-0 lg:flex-row flex-col lg:justify-between justify-center ${isDarkMode ? "dark" : ""} items-center bg-gray-100 dark:bg-dark-cBackground`}>
      <div className={`lg:w-[250px] w-full flex items-center mt-2 lg:mt-0 ${!data?.isActive ? 'bg-gray-300' : 'bg-green-500'} text-white px-4 py-2 rounded-md justify-center`}>
        {!data?.isActive ? t("professional.inactiveAccount") : t("professional.activeAccount")}
      </div>

      <UserRoleNavigation />

      <div className="w-[300px] flex items-center space-x-4">
        <div className="flex items-center space-x-2 gap-2 dark:text-white">
          <span>{getNameUser(roleList, data, userData)}</span>
          <UserCircleIcon
            className="size-8 stroke-textBrand fill-bgBrandLight dark:fill-transparent dark:stroke-bgBrandLight"
            onClick={() => handleLogout(true)}
          />
        </div>
      </div>
    </header>
  );
};